<template>
  <div class="page-container">
    <searchable-grid title="Businesses" :column-defs="columnDefs" :get-rows-promise="getRows" @cellDoubleClicked="onCellDoubleClicked">
      <template slot="actions">
        <el-button type="primary" icon="fa fa-plus" @click="createBusinessDialog = true" v-if="isAdmin">Create Business</el-button>
      </template>
    </searchable-grid>
    <el-dialog
      title="Create Business"
      :visible.sync="createBusinessDialog"
      width="600px">
      <edit-business-dialog @close="createBusinessDialog = false" @businessUpdated="onBusinessCreated" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api';
import SearchableGrid from '@/components/grid/SearchableGrid.vue';
import EditBusinessDialog from '@/components/dialog-content/EditBusiness.vue';

export default {
  components: {
    EditBusinessDialog,
    SearchableGrid,
  },
  data() {
    return {
      createBusinessDialog: false,
      columnDefs: [
        {
          headerName: '#',
          width: 50,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          pinned: true,
        },
        {
          headerName: 'Business Name',
          field: 'businessName',
          cellRenderer: (params) => {
            if (params.value !== undefined) {
              return params.value;
            }
            return '<i class="el-icon-loading"></i>';
          },
        },
        {
          headerName: 'Rep. Name',
          field: 'repName',
        },
        {
          headerName: 'Rep. Email',
          field: 'email',
        },
        {
          headerName: 'Rep. Phone',
          field: 'phone',
        },
        {
          headerName: 'City',
          field: 'city',
        },
        {
          headerName: 'State',
          field: 'state',
        },
        {
          headerName: 'Zip',
          field: 'zip',
        },
        {
          headerName: 'Office',
          field: 'officeId',
        },
      ],
    };
  },
  methods: {
    getRows(params) {
      return api.business.getGridData(params);
    },
    onCellDoubleClicked(event) {
      if (event.data && event.data.id) {
        this.$router.push({ name: 'businessDetail', params: { businessId: event.data.id } });
      }
    },
    onBusinessCreated(business) {
      this.$router.push({ name: 'businessDetail', params: { businessId: business.id } });
    },
  },
  computed: {
    ...mapGetters('User', [
      'isAdmin',
    ]),
  },
};

</script>

<style lang="scss" scoped>

</style>
